import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import DialogContent from "@material-ui/core/DialogContent";

import Close from "@material-ui/icons/Close";

import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button.jsx";
import Instruction from "../../../components/Instruction/Instruction";

import overviewStyle from "../../../assets/jss/material-kit-pro-react/views/presentationSections/overviewStyle.jsx";

import paymentMethods from "../../../assets/img/medios-pago-vec-2.jpg";
import imgMini from "../../../assets/img/ahorra-dinero.jpg";

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

class PaymentMethodsSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            classicModal: false,
            noticeModal: false,
            smallModal: false,
            openLeft: false,
            openTop: false,
            openBottom: false,
            openRight: false,
            checked: []
        };
    }

    handleClickOpen(modal) {
        let x = [];
        x[modal] = true;
        this.setState(x);
    }

    handleClose(modal) {
        let x = [];
        x[modal] = false;
        this.setState(x);
    }

    render() {
        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem md={2} sm={2}>
                </GridItem>
                <GridItem md={8} sm={8}>
                    <img
                        onClick={() => this.handleClickOpen("noticeModal")}
                        className={classes.paymentsImg}
                        src={paymentMethods}
                        alt="Metodos de pago"
                        title="Click para ver más"
                    />

                    {/* Modal */}
                    <Dialog
                        classes={{ root: classes.modalRoot, paper: classes.modal }}
                        open={this.state.noticeModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose("noticeModal")}
                        aria-labelledby="notice-modal-slide-title"
                        aria-describedby="notice-modal-slide-description"
                    >
                        <DialogTitle id="notice-modal-slide-title" disableTypography className={classes.modalHeader}>
                            <Button
                                simple
                                className={classes.modalCloseButton}
                                key="close"
                                aria-label="Close"
                                onClick={() => this.handleClose("noticeModal")}
                            >
                                {" "}
                                <Close className={classes.modalClose} />
                            </Button>
                        </DialogTitle>
                        <DialogContent id="notice-modal-slide-description" className={classes.modalBody}>
                            <Instruction
                                title="Promoción del mes"
                                text={
                                    <span>
                                        <strong>
                                        Si haces tu reservación consignando directamente en la cuenta bancaria de Vivamos
                                        el Campo, obtendrás un descuento del 2% en el pago de la misma.
                                        <br/>
                                        <br/>
                                        Cuenta de Ahorros Banco Popular
                                        <br/>
                                        No. 220-250-21688-4
                                        </strong>
                                    </span>
                                }
                                image={imgMini}
                                className={classes.instructionNoticeModal}
                                imageClassName={classes.imageNoticeModal}
                            />

                            <br/>
                            <p>
                                <strong>Para más información, contáctanos al 313 208 9988 o escribenos
                                a vivamoselcampo@gmail.com</strong>
                            </p>
                        </DialogContent>
                    </Dialog>
                    {/* End Modal */}
                </GridItem>
                <GridItem md={2} sm={2}>
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles(overviewStyle)(PaymentMethodsSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/PaymentMethodsSection.jsx